// src/Components/ErrorPages/ErrorBoundary.jsx
import { Component } from 'react';
import Error500 from './Error500';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary capturó un error:', error, info);
  }

  render() {
    if (this.state.hasError) return <Error500 />;
    return this.props.children;
  }
}

export default ErrorBoundary;
